import React, { useEffect, useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useNavigate, Link } from 'react-router-dom';

import 'react-datepicker/dist/react-datepicker.css';
import { toast } from 'react-toastify';
import './Guest.css';

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');

  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    localStorage.getItem('login') ? (
      navigate('/')
    ) : (
      console.warn('Please login')
    );

  }, [navigate]);

  const handleLogin = () => {
    setLoading(true);
    fetch("https://hospital.rozeetechnist.com/hospital-api/login.php", {
      method: "Post",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        'username': username,
        'password': password
      })
    }).then((result) => {
      result.json().then((resp) => {
        if (resp.status) {
          setLoading(false);
          localStorage.setItem('login', JSON.stringify(resp.data));
          toast.success(resp.message);
          navigate("/");
        } else {
          toast.error(resp.message);
          setLoading(false);
        }
      })
    })
  };

  // Logo configuration - set showLogo to true and add logo file to public folder
  const showLogo = false; // Set to true to show logo
  const logoPath = '/logo.png'; // Update this path to your logo file in public folder

  return (
    <div className="guest-container">
      <div className="guest-wrapper">
        {/* Hospital Title with Optional Logo */}
        <div className="guest-header-section">
          {showLogo && (
            <img
              src={logoPath}
              alt="Hospital Logo"
              className="guest-logo"
              onError={(e) => { e.target.style.display = 'none'; }}
            />
          )}
          <h1 className="guest-hospital-name">સુમરા હોસ્પિટલ</h1>
          <p className="guest-subtitle">Donation Management Portal</p>
        </div>

        {/* Login Form */}
        <div className="guest-form-container">
          <h2 className="guest-form-title">Login</h2>

          <div className="guest-input-group">
            <label className="guest-label">Mobile Number</label>
            <input
              type="text"
              className="guest-input"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="Enter mobile number"
              required
            />
          </div>

          <div className="guest-input-group">
            <label className="guest-label">Password</label>
            <input
              type="password"
              className="guest-input"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter password"
              required
            />
          </div>

          <button
            type="button"
            className="guest-button"
            onClick={handleLogin}
            disabled={loading}
          >
            {loading ? 'Please wait...' : 'Login'}
          </button>

          <div className="guest-link-section">
            <p className="guest-link-text">
              Dont have an account?{' '}
              <Link to="/register" className="guest-link">
                Register here
              </Link>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
